import { Menu, Item } from '@calendly/ui/components/menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import CardField from 'components/core/payment/stripe/card_field';
const loadingStateContainerCss = "l1ozxgr1";
export const LoadingStateContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(loadingStateContainerCss, props.className)} />;
});
const paragraphCss = "p18l6dbf";
export const Paragraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paragraphCss, props.className)} />;
});
const salesTaxInfoCss = "s1hwt80o";
export const SalesTaxInfo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(salesTaxInfoCss, props.className)} />;
});
const creditCardFieldCss = "cz2jhft";
export const CreditCardField = forwardRef((props, ref) => <CardField ref={ref} {...props} className={classNames(creditCardFieldCss, props.className)} />);
const changeCardContainerIsExpandedCss = "c1r8b0bo";
const changeCardContainerCss = "c1sw9kgy";
export const ChangeCardContainer = forwardRef((props, ref) => {
  const {
    isExpanded,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(changeCardContainerCss, {
    [changeCardContainerIsExpandedCss]: isExpanded
  }, props.className)} />;
});
const spacedBodyCss = "s10x09ss";
export const SpacedBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spacedBodyCss, props.className)} />;
});
const styledMenuCss = "smscpcw";
export const StyledMenu = forwardRef((props, ref) => <Menu ref={ref} {...props} className={classNames(styledMenuCss, props.className)} />);
const dropdownWrapperIsPhoneCss = "dmqdjln";
const dropdownWrapperCss = "d10j8cn6";
export const DropdownWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(dropdownWrapperCss, {
    [dropdownWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const selectedItemCss = "skf6g34";
export const SelectedItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(selectedItemCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");